export default __webpack_public_path__ + "static/media/2829 knife block B top.8cd040de.png";